import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';

const OutsourcingPilar9 = props => (
    <section id="outsourcing-pilar-section9" className="my pt-5 white-bg">
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-9.title')}</h2>
            <p className='mb-0'><Trans i18nKey="services:outsourcingPilar:section-9.text" components={{ br: <br /> }} /></p>
        </Container>
    </section>
);


export default OutsourcingPilar9;